module.exports = __webpack_public_path__ + "static/media/12.b3a6a9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/12.png
// module id = 1385
// module chunks = 0